<div
  class="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-4 w-full items-center justify-center bg-[url('/assets/Flow.jpg')] bg-cover bg-center h-[100vh]"
  *ngIf="!loading">
  <div></div>
  <main class="flex flex-col col-span-2 p-6 gap-6 rounded bg-white">
    <div class="flex flex-col items-center">
      <img alt="BizLab logo" class="object-contain w-28 max-w-full aspect-[2.67]" loading="lazy" src="assets/svg/logo.svg" />
    </div>

    <div class="grid grid-cols-2 sm:grid-cols-1 md:grid-cols-2 gap-4 h-[407px]" *ngIf="!invalidToken && availableMediaToUpload">
      <div class="flex flex-col flex-1 gap-4 h-full justify-between">
        <ng-container *ngIf="!uploadingDone else uploadCompleted">
          <header class="flex flex-col justify-center text-sm text-neutral-800">
            <h1 class="text-xl font-semibold ">Welcome</h1>
            <p class="leading-4">You have been provided with a unique link for uploading your media file content.</p>
            <p class="">Please use the upload box below.</p>
            <div class="grid grid-cols-3 gap-2">
              <div class="text-center border border-gray-300 rounded-md p-2 font-semibold">
                Up to {{ settings.limitForNumberOfLinks }} files
              </div>
              <div class="text-center border bg-green-100 border-gray-300 rounded-md p-2 font-semibold">
                {{remainingFilesLimit}} remaining
              </div>
              <div class="text-center border bg-blue-100 border-gray-300 rounded-md p-2 font-semibold">
                {{filesToUpload.length}} in queue
              </div>
            </div>
          </header>

          <div class="flex flex-col gap-5">
            <flow-drag-to-upload
              class="w-full"
              [supportedFileTypes]="supportedFileTypes"
              [multiple]="true"
              [maxUploadLimit]="remainingFilesLimit"
              [maxFileSize]="maxFileSize"
              [disabled]="remainingFilesLimit === filesToUpload.length || disableUpload"
              (maxUploadLimitError)="onMaxUploadLimitError()"
              (selectedFile)="selectFile($event)"></flow-drag-to-upload>

            <flow-button
              class="flex w-full"
              theme="primary"
              variation="fill"
              [fullWidth]="true"
              (click)="upload()"
              [disabled]="filesToUpload.length < 1 || disableUpload">
              <span>Transfer</span>
            </flow-button>
          </div>
        </ng-container>
      </div>

      <div #scrollContainer class="flex flex-col flex-1 gap-2 px-4 border-l border-gray-300 h-full overflow-y-auto scroll-smooth">
        <ng-container *ngIf="allFiles.length > 0; else noUploads">
          <flow-media-upload-item
            *ngFor="let file of allFiles; let i = index"
            [attr.upload-item-index]="i"
            [media]="file"
            [uploadingDone]="uploadingDone"
            [disableActions]="disableUpload"
            [mediaIndex]="i"
            (remove)="removeFile(i)"
            (reload)="upload(file)"></flow-media-upload-item>
        </ng-container>
      </div>
    </div>

    <ng-container *ngIf="invalidToken">
      <div class="flex flex-col items-center justify-center text-center h-full gap-3">
        <app-icon iconName="info" fill="#1f5792" size="xl"></app-icon>
        <div>
          <h3 class="mb-1 font-semibold">The provided link is invalid</h3>
          <p class="leading-3">Please contact support for more info</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="availableMediaToUpload === 0">
      <div class="flex flex-col items-center justify-center text-center h-full gap-3">
        <app-icon iconName="info" fill="#1f5792" size="xl"></app-icon>
        <div>
          <h3 class="mb-1 font-semibold">The media transfer limit for this link has been reached</h3>
          <p class="leading-3">Please contact support or use a new transfer link to continue</p>
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf="availableMediaToUpload === null && !invalidToken">
      <div class="flex flex-col items-center justify-center text-center h-full gap-3">
        <app-icon iconName="info" fill="#1f5792" size="xl"></app-icon>
        <div>
          <h3 class="text-center mb-1 font-semibold">The media transfer link has expired.</h3>
          <p class="leading-3">Please contact support to request a new one.</p>
        </div>
      </div>
    </ng-container>
  </main>

  <ng-template #uploadCompleted>
    <div class="flex flex-col items-center justify-center gap-3 min-h-[406px]">
      <div *ngIf="uploadingDone" class="flex flex-col items-center gap-3">
        <div class="flex justify-center items-center bg-brand-green rounded-full w-10 h-10">
          <app-icon iconName="checked" stroke="#fff" size="lg"></app-icon>
        </div>
        <h3 class="text-center font-semibold">Upload completed! You may close this window now.</h3>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #noUploads>
  <div class="flex flex-col flex-1 h-full justify-center items-center">
    <flow-no-data [title]="'No file(s) selected for upload'" [height]="'sm'"></flow-no-data>
  </div>
</ng-template>
